import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';
import Header from 'components/Header';
import API from 'utils/api';
import formatter from 'utils/formatter';
import Message from 'components/Message';
import CancelGoButtons from 'components/CancelGoButtons';

class MenuProductPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: null,
      product: null,
      showArchiveAlert: false,
      loading: true
    };
  }
  
  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.getProduct);
  }

  getProduct = () => {
    API.getProduct(this.state.productId)
      .then((response) => {
        this.setState({ product: response.data, loading: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  // Disable for now
  // toggleProductAvailability = () => {
  //   API.toggleMicroProductAvailability(this.state.productId)
  //     .then((response) => {
  //       this.getProduct();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }
  // 
  // <div style={{ marginBottom: '1.5em', display: 'flex', justifyContent: 'space-between' }}>
  //   { this.state.product.out_of_stock ? (
  //     <Label color="red" style={{ marginRight: '0.5em' }}>
  //       no disponible
  //     </Label>
  //   ) : (
  //     <Label color="green" style={{ marginRight: '0.5em' }}>
  //       disponible
  //     </Label>
  //   )}

  //   <Button icon circular onClick={this.toggleProductAvailability} size="mini">
  //     { this.state.product.out_of_stock ? (
  //       <Icon name="check" />
  //     ) : (
  //       <Icon name="close" />
  //     )}
  //   </Button>
  // </div>
  // 
  
  showArchiveAlert = () => {
    this.setState({showArchiveAlert: true})
  }

  hideArchiveAlert = () => {
    this.setState({showArchiveAlert: false})
  }

  archiveProduct = () => {
    API.archiveMicroProduct(this.state.productId)
      .then((response) => {
        // redirect to products page
        this.props.history.push('/menu/products');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleAddCost = () => {
    // Navigate to the product cost form
    this.props.history.push(`/menu/products/${this.state.productId}/cost`);
  }
  
  handleAddDescription = () => {
    // Navigate to the product description form
    this.props.history.push(`/menu/products/${this.state.productId}/description`);
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: 'center', padding: '2em' }}>
          <Icon loading name='spinner' size='large' />
          <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
        </div>
      );
    }
    
    if (!this.state.product) { 
      return (
        <div style={{ padding: '1.5em' }}>
          <Message>
            <p style={{ fontSize: '1.1em', textAlign: 'center' }}>
              No se encontró el producto.
            </p>
            <div style={{ textAlign: 'center', marginTop: '1.5em' }}>
              <Button 
                as={Link} 
                to="/menu/products"
                style={{
                  height: '54px',
                  fontSize: '1.1em',
                  borderRadius: '8px',
                  boxShadow: 'none'
                }}
              >
                Regresar al menú
              </Button>
            </div>
          </Message>
        </div>
      ); 
    }
    
    // Display archive confirmation
    if (this.state.showArchiveAlert) {
      return (
        <div style={{ marginTop: '1em' }}>
          <Message>
            <p style={{ textAlign: 'center', fontSize: '1.2em', marginBottom: '1.5em' }}>
              ¿Estás seguro de archivar este producto?
            </p>

            <p style={{ textAlign: 'center', fontSize: '1.4em', fontWeight: 'bold', marginBottom: '1.5em' }}>
              {this.state.product.name}
            </p>
            
            <p style={{ textAlign: 'center', fontSize: '1.1em', marginBottom: '1.5em', color: '#666' }}>
              Si archivas este producto ya no podrás volver a usarlo.
            </p>
  
            <CancelGoButtons
              cancelFn={this.hideArchiveAlert}
              cancelText="cancelar"
              goText="archivar"
              goEnabled={true}
              goFn={this.archiveProduct}
              warning={true}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }
              }}
            />
          </Message>
        </div>
      );
    }
    
    // Normal product display
    return (
      <div>
        <Header text={this.state.product.name} subtitle={this.state.product.product_category.name} />
        
        {/* Description section */}
        <div style={{ 
          marginBottom: '1.5em'
        }}>
          <div style={{ marginBottom: '8px' }}>
            <div style={{ 
              fontSize: '1.5em', 
              color: '#777'
            }}>
              Descripción
            </div>
          </div>

          {this.state.product.desc ? (
            <div style={{ 
              fontSize: '1.3em', 
              fontWeight: 'normal', 
              color: 'inherit',
              lineHeight: '1.4',
              marginTop: '5px'
            }}>
              {this.state.product.desc}
            </div>
          ) : (
            <div style={{
              marginTop: '5px'
            }}>
              <Button 
                onClick={this.handleAddDescription}
                primary
                style={{
                  height: '40px',
                  fontSize: '1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }}
              >
                agregar descripción
              </Button>
            </div>
          )}
        </div>

        {/* Price section */}
        <div style={{ 
          marginBottom: '1.5em'
        }}>
          <div style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ 
              fontSize: '1.5em', 
              color: '#777'
            }}>
              Precio
            </div>
            <div style={{ 
              fontSize: '1.8em', 
              fontWeight: 'normal', 
              color: '#555',
              textAlign: 'right'
            }}>
              {formatter.currency(this.state.product.price)}
            </div>
          </div>
        </div>
        
        {/* Cost section */}
        <div style={{ 
          marginBottom: '1.5em'
        }}>
          <div style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ 
              fontSize: '1.5em', 
              color: '#777'
            }}>
              Costo
            </div>
            {this.state.product.cost !== null && this.state.product.cost !== undefined ? (
              <div style={{ 
                fontSize: '1.8em', 
                fontWeight: 'normal', 
                color: '#555',
                textAlign: 'right'
              }}>
                {formatter.currency(this.state.product.cost)}
              </div>
            ) : (
              <Button 
                onClick={this.handleAddCost}
                primary
                style={{
                  height: '40px',
                  fontSize: '1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }}
              >
                agregar costo
              </Button>
            )}
          </div>
        </div>
        
        {/* Profit section */}
        {this.state.product.cost !== null && this.state.product.cost !== undefined && (
          <div style={{ 
            marginBottom: '1.5em'
          }}>
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div style={{ 
                fontSize: '1.5em', 
                fontWeight: 'bold',
                color: '#555'
              }}>
                Ganancia
              </div>
              <div style={{ 
                fontSize: '1.8em', 
                fontWeight: 'bold', 
                color: '#555',
                textAlign: 'right'
              }}>
                {formatter.currency(this.state.product.price - this.state.product.cost)}
              </div>
            </div>
          </div>
        )}
        
        {/* Separator */}
        <div style={{
          height: '1px',
          backgroundColor: '#ddd',
          width: '100%',
          margin: '3em 0 2em 0'
        }} />
        
        <CancelGoButtons
          cancelFn={() => this.props.history.push('/menu/products')}
          cancelText="regresar"
          goFn={this.showArchiveAlert}
          goText="archivar"
          goIcon="archive"
          goEnabled={true}
          warning={true}
          style={{
            button: {
              height: '54px',
              fontSize: '1.1em',
              fontWeight: 'bold',
              boxShadow: 'none',
              borderRadius: '8px'
            }
          }}
        />
      </div>
    )
  }
}

export default withRouter(MenuProductPage);